import {
  Lit3formBlock,
  html,
  unsafeHTML,
  icon,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  analyticsLabelFromString,
  handleFileDownloadEvent,
} from '../../../helpers/adobe-analytics';

export class Twyla extends Lit3formBlock {
  static get characterName() {
    return 'twyla';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid twyla-layout">
          ${this.firstImage
            ? html`
                <figure class="first-figure">
                  <img src="${this.imageUrl(this.firstImage)}" />
                  <figcaption>
                    ${this.figCaptionHTML(this.firstImage)}
                  </figcaption>
                </figure>
              `
            : html``}

          <div class="header-wrapper">
            <h2>${unsafeHTML(this.headingStr)}</h2>
            <div class="cta-wrapper">
              <cta-text
                cta-data=${this.ctaData()}
                .ctaAnalyticsData=${analyticsCtaDataObject(
                  this.ctaData(),
                  this.headingStr
                )}
              ></cta-text>
            </div>
          </div>
          <div class="paragraphs-wrapper">
            ${this.textSections.map(paragraph => {
              return html`
                <p class="paragraph">
                  ${unsafeHTML(this.withLineBreaks(paragraph))}
                </p>
              `;
            })}
          </div>
          ${this.secondImage
            ? html`
                <figure class="second-figure">
                  <img src="${this.imageUrl(this.secondImage)}" />
                  <figcaption>
                    ${this.figCaptionHTML(this.secondImage)}
                  </figcaption>
                </figure>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageUrl(img) {
    return this.imagebossUrl(img.src, 500, null);
  }

  ctaData(image) {
    let cta;
    if (image) {
      cta = image.cta;
    } else {
      cta = this.content.cta;
    }
    return JSON.stringify(cta);
  }

  imageDescription(img) {
    return img.description || '';
  }

  figureImageDownloadClicked(image) {
    const downloadData = {
      file_format: 'JPG',
      file_name: analyticsLabelFromString(image.description || this.headingStr),
      link_url: image.full_resolution_src,
      link_type: 'IMAGE',
      placement: analyticsLabelFromString(this.headingStr),
    };
    handleFileDownloadEvent(analyticsCtaDataObject(downloadData));
  }

  get headingStr() {
    return this.withLineBreaks(this.content.heading) || '';
  }

  get firstImage() {
    if (!this.imagesArr.length) return null;
    return this.imagesArr[0][1];
  }

  get secondImage() {
    if (!this.imagesArr.length) return null;
    return this.imagesArr[1][1];
  }

  get textSections() {
    if (
      !this.content.text_sections?.length ||
      !this.content.text_sections[0]?.paragraphs?.length
    ) {
      return [];
    }
    return this.content.text_sections[0].paragraphs;
  }

  figCaptionHTML(image) {
    return html`
      <image-caption description=${image.description || ''}>
        <a
          slot="control"
          href=${image.full_resolution_src}
          target="_blank"
          download
          @click="${() => this.figureImageDownloadClicked(image)}"
        >
          <span id="download-icon">
            ${icon('download-large')}
          </span>
        </a>
      </image-caption>
    `;
  }
}
Twyla.defineElement();
